import React, { useState } from 'react';
import { initials } from '../utils/format';

export default function Avatar(props) {
  const [failed, setFailed] = useState(false);
  const showImage = props.photo && !failed;

  return (
    <div className="avatar">
      {showImage ? (
        <img
          className="avatar__image"
          src={props.photo}
          alt={props.name ? 'Profile photo of ' + props.name : 'Profile photo'}
          onError={function () {
            setFailed(true);
          }}
        />
      ) : (
        <span className="avatar__initials" aria-hidden="true">
          {initials(props.profile)}
        </span>
      )}
    </div>
  );
}
